/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    noResults: "該当する結果が見つかりませんでした",
    actions: "操作",
    add: "追加",
    edit: "編集",
    view: "表示",
    back: '戻る',
    save: "保存",
    cancel: "キャンセル",
    delete: "削除",
    ok: "はい",
    confirm: "確認",
    deleteConfirmMsg: "本当に削除してもよろしいですか？",
    no: "いいえ",
    yes: "はい",
    visible: "Visible",
    hidden: "Hidden",
    on: "On",
    off: "Off",
    noDataAvailable: "利用可能なデータがありません",
    pagination: {
      rowsPerPage: "Rows per page:",
      range: "{{from}}–{{to}} of {{total}}",
      page: "Page",
      pageInput: "Page number",
      ofPages: "of {{total}}",
      firstPage: "First page",
      previousPage: "Previous page",
      nextPage: "Next page",
      lastPage: "Last page",
      invalidPage: "Enter a page from 1 to {{total}}",
    },
    reason: "理由",
    createdBy: "作成者",
    modifiedBy: "変更者",
    close: "閉じる",
    loadingText: "データを読み込んでいます。お待ちください。",
    search: "検索",
    paracetamol: "パラセタモール",
    disable: "使用停止にする",
    disabled: "Disabled",
    enable: "使用可能にする",
    enabled: "Enabled",
    editable: "編集可能",
    readOnly: "読み取り専用",
    tenant: "組織",
    languageSwitch: "言語変更",
    ac: "管理者センター",
    dashboard: "ダッシュボード",
    signOut: "サインアウト",
    revert: "元に戻す",
    list: "リスト",
    showDeletedRecords: "削除された登録内容を表示",
    recordID: "登録ID",
    recordName: "登録名",
    description: "説明",
    status: "ステータス",
    association: "関連付け",
    type: "区分",
    mandatory: "必須",
    optional: "任意",
    information: "情報",
    createdDate: "作成日",
    modifiedDate: "変更日",
    basicInformation: "基本情報",
    details: "詳細",
    level: "レベル",
    update: "更新",
    lock: "ロック",
    unlock: "ロック解除",
    typeofAssociation: "連結の種類",
    recordDeleteTip:
      "以下の依存関係があるため、登録を<b>削除できません</b>。",
    recordStatusTip:
      "以下の依存関係があるため、ステータスを<b>変更できません</b>。",
    comments: "コメント",
    clear: "解除",
    apply: "適用",
    clearFilter: "フィルターを解除",
    downloadPDF: "PDFをダウンロード",
    downloadCSV: "CSVをダウンロード",
    downloadExcel: "Excelをダウンロード",
    tokenIsExpired: "トークンの有効期限が切れています",
    collapse: "折りたたむ",
    expand: "展開",
    continue: "Continue",
    tip: {
      addSuccess: "追加が完了しました。",
      addFailed: "追加ができませんでした。",
      updateSuccess: "更新が完了しました。",
      updateFailed: "更新ができませんでした。",
      revertSuccess: "元の状態に戻すことに成功しました。",
      revertFailed: "元の状態に戻せませんでした。",
      deleteSuccess: "削除が完了しました。",
      deleteFailed: "削除ができませんでした。",
      deletion: "削除理由を入力してください。",
      limit_2000: "最大文字数2000文字を超えています。",
      selectOneItem: "1つの項目を選択してください。",
      selectTarget: "最初に対象を選択してください。",
      jsonError: 'JSON形式が正しくありません。正しいJSON形式で入力してください。'
    },
    createdDateAndTime: "作成日時",
    modifiedDateAndTime: "変更日時",
    audit: "監査ログ",
    deleteSelected: "選択した項目の削除",
    next: "次へ",
    submit: "アップロード",
    import: "インポート",
    export: "エクスポート",
    importInfo: "情報のインポート",
    importTips: "If {{type}} already exists, the imported data will overwrite {{name}} current information",
    downloadTemplate: "テンプレートをダウンロード",
    unsavedChange: {
      title: "保存されてない変更",
      content: "このページを離れてもよろしいですか？ 保存されていない変更はすべて失われます。"
    },
    importFile: {
      tips: {
        noFileChoose: "ファイルを選択するか、キャンセルをクリックしてこの画面を閉じてください。",
        fileFormatError: "ファイルの形式が許可されていません。",
        fileDuplicate: "重複するファイルを確認し、削除してください。",
        importingDate: "データをインポートしています。しばらくお待ちください。",
        importSuccess: "ファイルがインポートされました。",
        uploadSuccess: "ファイルがアップロードされました。",
        importFailure: "失敗回数",
        moreThanOne: "複数のファイルを添付できません",
        FailToImport: "File import failed. Please make sure the file is valid and try again.",
        contentIsTooLarge: "File content is too large to import. Please reduce the file size and try again.",
        importInProgress: "An import is already running for this module. Wait for it to finish, then try again.",
        importTimeout: "The import is taking longer than expected. Reopen this page later to check the result.",
      }
    },
    businessRule: {
      title: "ビジネスロジックルール設定",
      source: 'ソース',
      name: '名',
      field: 'フィールド',
      rule: 'ルール',
      values: '値',
      required: '{{fieldName}}は必須項目です',
      exists: '存在する',
      equals: '以下と等しい',
      notEquals: 'Not Equals',
      in: '以下の中に',
      notIn: 'Not In',
      where: 'Where',
      module: 'モジュール',
      group: 'グループ',
      menu: 'メニュー'
    },
    jsonLabel: 'JSON',
    avatar: "プロファイル",
    upload: {
      noFileChosen: "ファイルが選択されていません",
      buttonLabel: "ファイルを選択",
      header: "ファイルをここにドラッグ＆ドロップしてください",
      buttonRemoveLabel: "すべて削除",
      or: "または"
    },
    loading: {
      exportData: "データをエクスポート中です。完了後、ダウンロードを確認してください。",
      exportDataTip: "We are currently exporting your data. Please check your downloads once its completed.",
      downloadTemplate: "テンプレートをダウンロード中です。完了後、ダウンロードを確認してください。"
    },
    tips: {
      downloadFailed: "ダウンロードに失敗しました。"
    },
    required: "required",
    order: "Order",
    rule: "Rule"
  },
  validation: {
    isRequired: "は必須項目です"
  },
  commonFilter: {
    filters: "フィルター",
    filterby: "フィルター条件",
    select: "選択",
    search: "検索",
    clearFilters: "フィルターの解除"
  },
  personage: {
    tip: {
      pwUpdateSuccess: "パスワードが変更されました。",
      pwUpdateLimit:
        "パスワード変更回数の上限を超えました。システム管理者に連絡してください。",
    },
  },
  menu: {
    searchModule: "検索機能",
    modules: "モジュール",
    showMenu: "メニューを表示",
    hideSideMenu: "メニューを非表示",
    showNavigationSidebar: "ナビゲーションサイドバーを表示",
    uam: "ユーザーアクセス管理",
    users: "ユーザー",
    roles: "ルール",
    userGroups: "ユーザーグループ",
    accessControl: "アクセス制御",
    distribution: "配信リスト",
    cm: "設定マネージャー",
    menuManager: "メニューマネージャー",
    formManager: "フォーム様式マネージャー",
    gridManager: "グリッドマネージャー",
    audit: "監査ログ レポート",
    notifications: "通知",
    templates: "テンプレート",
    payloads: "ペイロード",
    tasks: "タスク",
    history: "履歴",
    importACL: "アクセス制御をインポート",
    importUser: "ユーザーをインポート",
    importGroup: "ユーザーグループをインポート",
    importRole: "役割をインポート",
    workflowManager: "ワークフロー管理",
    knowledgeManager: "ナレッジ管理",
    processManager: "プロセス管理",
    eventManager: "Event Manager",
    docsManager: "Docs Manager",
    uiManager: "UI Manager",
    archiveManager: "Archive Manager",
    planAndAutomation: "Plan & Automation",
    platformRelatedReports: "レポート",
    taskManager: "タスク管理",
    templateManager: "テンプレート管理",
    templateAutoLauncher: "テンプレートオートロンチャー",
    importDistribution: "配信をインポート",
    clients: "Clients",
    scim: "SCIM",
  },
  scimManager: {
    title: "SCIM Configuration",
    baseUrl: "SCIM Base URL",
    secretToken: "Secret Token",
    status: "Status",
    expiresAt: "Expires At",
    validUntil: "Valid until",
    neverExpires: "Does not expire",
    graceExpiresAt: "Previous token grace until",
    defaultGraceHours: "Default grace period (hours)",
    generate: "Generate",
    rotate: "Rotate",
    revoke: "Revoke",
    delete: "Delete",
    revokeTitle: "Revoke SCIM Credential",
    deleteTitle: "Delete SCIM Credential",
    copyBaseUrl: "Copy Base URL",
    copySecret: "Copy Secret Token",
    disabledMessage:
      "SCIM is not enabled for this tenant. Contact your platform administrator.",
    secretOnceWarning:
      "This secret is shown only once. Copy it now and store it securely. You will not be able to view it again.",
    generateTitle: "Generate SCIM credential",
    rotateTitle: "Rotate SCIM credential",
    revokeConfirm:
      "Revoke this SCIM credential? Requests using this token will stop immediately.",
    deleteConfirm:
      "Delete this SCIM credential from the list? This cannot be undone.",
    expiresInDays: "Token expiration",
    gracePeriodHours: "Grace period for previous token (hours)",
    tokenExpiresIn: "Token expires in",
    newTokenExpiresIn: "New token expires in",
    previousTokenValidFor: "Previous token remains valid for (hours)",
    tokenExpirationTooltip:
      "Sets how long this generated token remains valid. Select Does not expire for no calendar expiration.",
    newTokenExpirationTooltip:
      "Sets how long the new token generated by this rotation remains valid.",
    previousTokenGraceTooltip:
      "Sets how long the token being rotated remains valid. Select 0 to revoke it immediately.",
    secretGenerated: "SCIM credential generated.",
    secretRotated: "SCIM credential rotated.",
    revoked: "SCIM credential revoked.",
    deleted: "SCIM credential deleted.",
    baseUrlCopied: "SCIM Base URL copied to clipboard.",
    secretCopied: "Secret Token copied to clipboard.",
    close: "Close",
    credentialsList: "Credentials",
    credentialsTimeHint: "Times are shown in your regional time zone.",
    noCredentials: "No credentials yet. Generate a token to get started.",
    rotatedAt: "Rotated At",
    statusActive: "Active",
    statusGrace: "Previous (still valid)",
    statusExpired: "Expired",
    statusRevoked: "Revoked",
    graceBanner:
      "Previous token(s) are still accepted until the time(s) below. Update your IdP Secret Token before then.",
    remainingInDays: "in {{count}} day(s)",
    remainingInHours: "in {{count}} hour(s)",
    remainingSoon: "less than 1 hour",
    remainingPast: "ended",
    quotaWarning:
      "User quota is {{used}} of {{quota}} used. New SCIM users will fail once the limit is reached. Updates to existing users will continue.",
    quotaReachedBody:
      "SCIM will not create new users. Updates to existing users can still succeed.",
  },
  menuManager: {
    listLabel: '{{type}}リスト',
    label: "メニューリスト",
    menuName: "メニュー名",
    group: "Group",
    groupDisplayName: "Group Display Name",
    module: "モジュール名",
    domain: "領域",
    type: "区分",
    status: "ステータス",
    visibility: "Visibility",
    generateGrid: "グリッドを生成",
    generateRecordId: "Generate Record ID",
    linkItem: "Link Item",
    requiresGenerateGridEnabled: "Requires 'Generate Grid' to be enabled.",
    goToMenuList: "Go to Menu List",
    addGroup: "グループを追加",
    addMenu: "メニューを追加",
    sectionOrder: "順序",
    menu: "メニュー",
    labelPath: 'ツリーラベルフィールド',
    selectTheLabelPathField: "ツリーラベルフィールドを選択",
    linkLabelPathTip: "このメニューに表示するフィールドを、登録/申請ウィザードに選択してください。",
    verify: "{{fieldName}}が必要です",
    moduleNotAvailable: 'Previous module not available.',
    deleteGroupConfirmMsg: 'グループを削除してもよろしいですか？関連するメニューもすべて削除されます。',
    deleteMenuConfirmMsg: 'メニューを削除してもよろしいですか？関連するフォームとグリッドもすべて削除されます。',
    inheritIdentifier: 'Inherit Identifier',
    setupInheritIdentifier: 'Setup Inherit Identifier',
    badgeHeader: 'Header Badge',
    setupBadgeHeader: 'Setup Header Badge',
    usedInLinkedRecords: 'Used in Linked Records',
    usedInLinkedRecordsHelpTip: 'Check this to use this field as the identifier used in cross-module Linked Records query. Please note: This is a permanent change. Once checked, this setting cannot be reversed, and the field itself cannot be deleted or disabled.',
    linkedRecordConfirmMessage: 'The field {{fieldName}} is permanently used in cross-module Linked Records query. Therefore, this setting cannot be reversed.',
    linkedRecordIdentifierConfirmMessage: 'You are about to make {{fieldName}} a permanent Linked Records Identifier. This action cannot be undone. Are you sure you want to continue?',
    separatorRequired: "Please fill the Separator first.",
    separator: "Separator",
    setupTreeLabelField: "Setup Tree Label Field",
    fullExport: "Full Export",
    menuExport: "Menu Export",
    fullImport: "Full Import",
    menuImport: "Menu Import",
    importWizardOverrideWarning: "This will overwrite related configurations in Wizard Manager and Form Manager.",
    importFullOverrideWarning: "This will overwrite all configurations, including related settings in Menu Manager, Wizard Manager, Form Manager, and Grid Manager.",
    importMenuOverrideWarning: "This will overwrite related configurations in Menu Manager, Form Manager, and Grid Manager.",
    goToFieldList: "Go to Field List",
    changeTypeConfirmMessage: "You are about to change the Type for {{menuName}}. This will clear the existing Business Rules, and you will need to set them up again manually. Are you sure you want to continue?",
    statusDisableHelpTip: "Menu cannot be disabled if it contains mandatory, conditional mandatory or auto-tagged fields.",
    visibilityDisableHelpTip: "Visibility is set to hidden when the Status field is disabled.",
    objectName: "Object Name",
    objectDisplayName: "Object Display Name",
    objectMainGridConfig: "Object Main Grid Config",
    objectMainGridSourceFormat:
      "Form Name · Type · Module > Object > Group(Wizard)",
    setupObjectMainGrid: "Configure Object Main Grid",
    mainGridName: "Main Grid Name",
    mainGridConfigurationTitle: "Main Grid Configuration",
    mainGridConfigurationDescription:
      "Define grid hierarchy nodes, assign a source per node, and choose visible columns.",
    switchObjectUnsavedWarning:
      "Switching the object will discard unsaved changes. Continue?",
    switchObjectStay: "Stay",
    loadConfigFailed:
      "Failed to load Object Main Grid configuration. Please try again.",
    objectHeaderBadgeConfig: "Object Header Badge Config",
    setupObjectHeaderBadge: "Setup Object Header Badge",
    addObjectHeaderBadgeRule: "Add Rule",
    objectHeaderBadgeSourceHint:
      "Form Name · Type · Module > Object > Group(Step)",
    objectHeaderBadgeSourceSearchPlaceholder: "Search by Form/Grid name",
    loadObjectHeaderBadgeFailed:
      "Failed to load Object Header Badge configuration. Please try again.",
  },
  gridManager: {
    label: "グリッド形式",
    gridName: "グリッド名",
    module: "モジュール",
    domain: "領域",
    sectionMenu: "セクション/セクション/メニュー",
    group: "Group",
    form: {
      order: "順序",
      column: "列",
      type: "区分",
      gridAvailability: "グリッドの可用性",
      visibility: "可視性",
      groupBy: "Group by",
      sortBy: "Sort by",
      gridDensity: "Grid density",
      pageSize: "Page size",
      none: "--None--",
      asc: "Asc",
      desc: "Desc",
      custom: "Custom",
      customPageSizeInput: "Custom page size",
      customPageSizeHint: "Custom: {{count}} rows per page",
      customPageSizeRequired: "Custom: Page size is required",
      customPageSizeMoreThan0: "Custom: Page size must be more than 0",
      pageSizeRows: "{{count}} rows",
      density: {
        Compact: "Compact",
        Standard: "Standard",
        Comfortable: "Comfortable",
      },
    },
  },
  wizardManager: {
    listLabel: "Wizard List",
    wizardName: "Wizard Name",
    module: "Module",
    domain: "Domain",
    section: "Section",
    definition: "Definition",
    wizard: "Wizard",
    name: "Name",
    step: "Step",
    type: "Type",
    status: "Status",
    visibility: "Visibility",
    generateGrid: "Generate Grid",
    addGroup: "Add Group",
    addMenu: "Add Menu",
    menu: "Menu",
    sectionOrder: "Order",
    displayName: "Display Name",
    wizardDisplayName: "Wizard Display Name",
    description: "Description",
    addWizard: "Add Wizard",
    goToStepList: "Go to Step List",
    addWizardGroup: "Add Wizard Group",
    addWizardGroupForm: "Add Wizard Group Form",
    addWizardGroupFormField: "Add Wizard Group Form Field",
    deleteWizardConfirmMsg: 'Are you sure you want to delete the wizard? All the associated steps will also be deleted.',
    deleteStepConfirmMsg: 'Are you sure you want to delete the step? All the associated forms will also be deleted.',
    statusDisableHelpTip: "Step cannot be disabled if it contains mandatory, conditional mandatory or auto-tagged fields.",
    visibilityDisableHelpTip: "Visibility is set to hidden when the Status field is disabled.",
  },
  formManager: {
    label: "フォームリスト",
    formName: "フォーム名",
    module: "モジュール",
    domain: "領域",
    section: "セクション",
    groupWizard: "Group/Wizard",
    groupWizardDisplayName: "Group/Wizard Display Name",
    groupDisplayName: "Group Display Name",
    definition: "Definition",
    field: {
      label: "入力フィールドリスト",
      order: "順序",
      fieldName: "入力フィールド名",
      fieldType: "入力フィールド区分",
      type: "区分",
      permission: "許可",
      status: "ステータス",
      visibility: "Visibility",
      tenantLabel: "組織名",
      infoText: "情報テキスト",
      regulations: "規制",
      addField: "入力フィールドを追加",
      span: "間隔",
      rows: "行",
      length: "文字数制限",
      dataSource: "データソース",
      businessRule: "ビジネスルール",
      linkCascading: "リンクカスケードフィールド",
      editJson: 'JSONを編集',
      addJson: "JSONを追加",
      jsonLabel: 'JSON',
      addRule: "ルールを追加",
      productType: "区分",
      productSubcategory: "サブカテゴリー",
      productCategory: "カテゴリー",
      minimum: "Minimum",
      maximum: "Maximum",
      placeholder: "Placeholder",
      regularExpression: "Regular Expression",
      minimumLength: "Minimum Length",
      maximumLength: "Maximum Length",
      minimumDate: "Minimum Date",
      maximumDate: "Maximum Date",
      invalidRegularExpression: "Invalid regular expression. Please check and retry.",
      changeDataSourceConfirmMessage: "You are about to change the Data Source for {{fieldName}}. This will clear the existing Grid Criteria, and you will need to set them up again manually. Are you sure you want to continue?",
      autoTaggingIdentifier: "Auto-Tagging Identifier",
      autoTaggingIdentifierHelpTip: "Turn this on to automatically use this field as an identifier and tag for every record in this business module. Please note: This is a permanent change. Once enabled, this setting cannot be reversed, and the field itself cannot be deleted or disabled.",
      autoTaggingIdentifierConfirmMessage: "Your are about to make {{fieldName}} a permanent Auto-Tagging Identifier. This action cannot be undone and the field cannot be deleted or disabled. \n\nAre you sure you want to continue?",
      autoTaggingEnabledTooltip: "Auto-Tagging is permanently enabled for field {{fieldName}}. Therefore, this setting cannot be deleted or disabled.",
      selectionMode: "Selection Mode",
      single: "Single",
      multiple: "Multiple",
      valueGeneratedBySystem: "Value Generated by System",
      statusDisableHelpTip: "Field should not be able to disabled if the field is mandatory or conditional mandatory.",
      visibilityDisableHelpTip: "Visibility is set to hidden when the Status field is disabled.",
      sourceField: "Source Field",
      property: "Property",
      moduleSpecific: "Module Specific",
      conditionalReadOnly: "Conditional Read Only",
      notFoundById: "Fields not found in current tenant",
      staticText: {
        textVariant: "Text Variant",
        heading1: "Heading 1",
        heading2: "Heading 2",
        heading3: "Heading 3",
        heading4: "Heading 4",
        heading5: "Heading 5",
        heading6: "Heading 6",
        subtitle1: "subtitle 1",
        subtitle2: "subtitle 2",
        textVariantRequired: "Text Variant is required",
      },
      separatorLine: {
        visualAndLayout: "Visual & Layout",
        lineStyle: "Line Style",
        verticalSpacing: "Vertical Spacing",
        indentation: "Indentation",
        solid: "Solid",
        dashed: "Dashed",
        none: "None",
        small: "Small",
        medium: "Medium",
        large: "Large",
        fullWidth: "Full Width",
        inset: "Inset",
        middle: "middle",
        embeddedText: "Embedded Text",
        enableEmbeddedText: "Enable Embedded Text",
        textValue: "Text Value",
        textValuePlaceholder: "Enter text to display on the separator line",
        textAlignment: "Text Alignment",
        textStyle: "Text Style",
        left: "Left",
        center: "Center",
        right: "Right",
        middleSize: "Middle",
        visualLayoutRequired: "Line Style, Vertical Spacing, and Indentation are required",
        textValueRequired: "Text Value is required when Embedded Text is enabled",
      },
      compositeComponent: {
        gridConfigurationTitle: "Composite Grid Configuration",
        gridConfigurationHelp:
          "Rename grid nodes and reorder child/sibling nodes under the parent grid.",
        hierarchy: "Hierarchy",
        emptyHint: "No components yet. Use Add child to create the first one.",
        noSelection: "Select a component to configure its source and visible fields.",
        rootHint: "Please add nodes in the hierarchy area on the left first, so you can proceed to configure the source and visible fields for each node.",
        source: "Source",
        visibleFields: "Visible Fields",
        visibleFieldsHelp: "Check columns to show. Drag to reorder.",
        column: "Column",
        columnType: "Type",
        toggleAllVisible: "Select all / deselect all",
        addChildTitle: "Add child component",
        addSiblingTitle: "Add sibling component",
        renameTitle: "Rename component",
        nameRequired: "Name is required.",
        nameDuplicate: "A sibling with this name already exists.",
        saveWarningTitle: "Confirm",
        emptyStructureWarning:
          "The composite component structure is empty. No component nodes have been configured.\nDo you want to save anyway?",
        missingSourceWarning:
          "One or more component nodes have no Source selected.\nDo you want to save anyway?",
        deleteTitle: "Delete component",
        deleteMessage: "Delete this component?",
        descendantWarning: "This component and all of its nested components will be removed.",
        toolbar: {
          addChild: "Add child",
          addSibling: "Add sibling",
          edit: "Edit",
          delete: "Delete",
          moveUp: "Move up",
          moveDown: "Move down",
        },
      },
    },
    tip: {
      jsonError: '不正なJSON形式です。正しいJSON形式を入力してください。'
    },
    businessRule: {
      dependencyType: 'Dependency Type',
      title: "ビジネスロジックルールを設定する",
      field: '入力欄',
      rule: 'ルール',
      values: '値',
      required: '{{fieldName}}は必須項目です',
      exists: '存在する',
      equals: '一致する',
      notEquals: 'Not Equals',
      in: '中に',
      notIn: 'Not In'
    },
    conditionalReadOnly: {
      title: "Setup Conditional Read Only Rules",
    },
    linkCascadingField: {
      title: "Link Cascading Field",
      label: "Cascading Field",
      helpTip: "カスケードフィールドとして使用できるのは、ナレッジマネージャー内の関連する概念のみです。",
    },
    dependencyValidation: {
      label: "Dependency Validation",
      title: "Setup Dependency Validation",
      helpTip: "Avoid configuring conflicting rules between Dependency Validation and field-level Validation, as contradictory validations may prevent the form from being saved.",
      compareWithType: "Compare With",
      currentDate: "Current Date",
    },
    duplicateValidation: {
      title: "Setup Duplicate Validation Rules",
      action: "Duplicate Validation Rule",
      compositions: "Compositions",
    },
    gridCriteria: {
      title: "Setup Grid Criteria",
      label: "Grid Criteria",
      addCriteria: "Add Criteria",
      addRule: "Add Rule",
      andOr: "And/Or",
      module: "Module",
      type: "Value Source",
      groupWizard: "Group",
      menuStep: "Menu",
      field: "Field",
      rule: "Rule",
      values: "Values",
      menuGroup: "Menu Group",
      wizard: "Wizard",
      is: "Is",
      exists: "Exists",
      equals: "Equals",
      notEquals: "Not Equals",
      in: "In",
      notIn: "Not In",
      where: "Where",
      required: "{{fieldName}} is required",
      and: "And",
      or: "Or",
      wizardReference: "Wizard Reference",
      clickToConfigure: "Click to configure…",
      step: "Step",
      fromMenuGroup: "From Menu Group",
      fromWizard: "From Wizard",
    },
    extraJson: {
      action: "Customize Form JSON"
    }
  },
  userManager: {
    users: "ユーザー",
    associateUser: "複数組織ユーザー",
    description:
      "ユーザー管理機能では、ユーザーの作成と管理を行います。",
    profileDetails: "プロファイル設定詳細",
    loginGroupDetails: "ログイン グループ詳細",
    reassignUser: "ユーザーの再割り当て",
    resetPassword: "パスワードをリセットする",
    sendActivationLink: "アクティベーションリンクを送信",
    setAsPrimary: "プライマリに設定",
    reassignPrimaryTenant: "プライマリテナントの再割り当て",
    deleteUser: "選択したユーザーは削除されます。続行しますか？",
    disassociateUser: "選択したユーザーは、この組織から解除されます。続行しますか？",
    lockUser: "ユーザーをロックしますか？",
    unLockUser: "ユーザーのロックを解除しますか？",
    unlockUserTip:
      "この操作を行うと、ユーザーロックが解除され、ログインが可能になります。",
    lockUserTip:
      "この操作を行うと、ユーザーがロックされアプリケーションにログインできなくなります。",
    deleteUserWithDependency:
      "このユーザーに紐づけられた情報があります。削除しますか？",
    onlyAssociatedUsersCanBeSetAsPrimary: "関連付けられたユーザーのみがプライマリユーザーに設定できます。",
    pleaseDeselectPrimaryUsersAndRetry: "現在選択されているプライマリユーザーの選択を解除して再試行してください。",
    someSelectedUsersAreInactiveOrArchived: "選択したユーザーの一部が非アクティブまたはアーカイブされており、プライマリユーザーに設定できません。",
    pleaseDeselectInactiveAndArchivedUsersAndTryAgain: "非アクティブおよびアーカイブされたユーザーの選択を解除して再試行してください。",
    userQuotaReached:
      "The maximum number of users is {{quota}}. If you need to add more users, please contact the Freya Fusion Support Team.",
    userQuotaChipUsed: "{{used}} of {{quota}} used",
    userQuotaRemaining: "{{remaining}} remaining",
    userQuotaReachedLabel: "Quota reached",
    userQuotaTooltipStats: "{{used}} used of {{quota}} · {{remaining}} remaining",
    userQuotaTooltipStatsReached: "{{used}} used of {{quota}} · Quota reached",
    userQuotaIncludedLabel: "Included",
    userQuotaIncludedRule:
      "In-Draft, Active, Inactive (including Locked), and associated users",
    userQuotaExcludedLabel: "Excluded",
    userQuotaExcludedRule: "Deleted and Archived",
    userQuotaImportNotImported:
      "The entire file was not imported. No users were created and no existing users were updated.",
    userQuotaImportRemaining: "{{remaining}} user quota remaining",
    userQuotaImportNewUsers: "{{count}} new users in this file",
    userQuotaImportUpdates: "{{count}} updates not applied",
    userQuotaImportDownloadDetails: "Download details ({{count}} new users)",
    userQuotaAssociateNoneAssociated:
      "None of the selected users were associated. Remaining quota is {{remaining}}; {{selected}} users were selected.",
    user: {
      label: "ユーザー",
      emailID: "メールアドレス",
      firstName: "名",
      lastName: "氏",
      middleName: "ミドルネーム",
      countryGroup: "国/国グループ",
      country: "国",
      mobile: "携帯番号",
      phone: "電話番号",
      city: "市",
      loginGroup: "ログイングループ",
      businessUnit: "部署",
      authenticationMechanism: "認証方式",
      disassociateUser: 'ユーザーを解除',
      mfaConfig: "多要素認証の設定",
      mfaConfigTip: "多要素認証の設定は、SSO認証方式のユーザーにのみ適用されます。ログインパスワード認証方式のユーザーは、既存の多要素認証設定は変更されません。",
      loginGroupConfirm: "ログイングループは一度保存すると変更できません。\n選択したログイングループで続行してもよろしいですか？",
      accountLock: "Account Lock",
      locked: "Locked",
      unlocked: "Unlocked",
    },
    tip: {
      updateStatusSuccess: "ユーザーステータスが更新されました。",
      disassociatedSuccess: "ユーザーが解除されました。",
      associatedSuccess: "ユーザーの関連付けが設定されました。",
      usersAssociatedSuccess: "ユーザーが関連付けられました。",
      exists: "このユーザーはすでに登録されています。",
      updateSuccess: "ユーザーが更新されました。",
      intructionsSent: "アカウントの設定手順がユーザーに送信されました。",
      emailExists: "このメールアドレスはすでに使用されています。異なるメールアドレスを使用してください。",
      deleteSuccess: "ユーザーが削除されました。",
      sendSetupPswEmail:
        "パスワードリセットのメールがユーザーに送信されました。",
      sendActivationLink:
        "メール認証リンクがユーザーに送信されました。",
      setPrimarySuccess: "プライマリユーザーが正常に設定されました。",
      lockedSuccess: "ユーザーのロックが完了しました。",
      unlockedSuccess: "ユーザーのロックが解除されました。",
      lockedFailed: "ロックができませんでした。",
      unlockedFailed: "ロック解除ができませんでした。",
    },
    verify: {
      phone: "正しい電話番号を入力してください",
      mobile: "正しい携帯電話番号を入力してください",
      email: "正しいメールアドレスを入力してください",
      emailEmpty: "メールアドレスは必須項目です",
      firstNameEmpty: "名は必須です",
      lastNameEmpty: "姓は必須です",
      loginGroupEmpty: "ログイングループを選択してください",
      mechanismEmpty: "認証方式を選択してください",
    },
  },
  roleManager: {
    roles: "役割",
    description:
      "役割機能により、ユーザーに対して1つまたは複数の権限セットを組み合わせることができます。",
    profileDetails: "プロファイル設定詳細",
    loginGroupDetails: "ログイングループ詳細",
    deleteRole: "選択した役割が削除されます。続行しますか？",
    importRoleAndACL: "Import Role & ACL",
    importRoleAclConfirmTitle: "Import Role & ACL",
    importRoleAclConfirmP1:
      "続行する前に、関連する ACL と権限がすべて正常にインポートされていることを確認してください。JSON ファイルの選択が求められます。",
    importRoleAclConfirmWarning:
      "この JSON インポートは既存の設定を上書きする場合があります。",
    importRoleAclConfirmP2:
      "ファイルの内容に応じて、次の一致するレコードが置き換えられる場合があります。",
    importRoleAclConfirmLi1: "役割",
    importRoleAclConfirmLi2: "役割とアクセス制御（ACL）のマッピング",
    exportRoleAndACL: "Export Role & ACL",
    exportRoleWithPrivilegesJson: "Export Role with Privileges (JSON)",
    role: {
      label: "役割",
      roleName: "役割名",
      roleType: "役割種類",
      roleLevel: "Role Level",
      roleLevelTip: "A lower number means higher privilege.",
      source: "ソース"
    },
    tip: {
      updateStatusSuccess: "役割が更新されました。",
      disassociatedSuccess: "役割が解除されました。",
      associatedSuccess: "役割の関連付けが設定されました。",
      exists: "この役割はすでに登録されています。",
      addSuccess: "役割が作成されました。",
      updateSuccess: "役割が更新されました。",
      deleteSuccess: "役割が削除されました。",
      exportRoleConfigSuccess: "役割設定をエクスポートしました。",
    },
  },
  userGroupManager: {
    userGroups: "ユーザーグループ",
    description:
      "すべてのユーザーをグループ化してこちらで管理できます。",
    deleteUserGroup: "選択したユーザーグループが削除されます。続行しますか？",
    importUserGroupAndRole: "Import User Group & Role",
    importGroupRoleConfirmTitle: "Import User Group & Role",
    importGroupRoleConfirmP1:
      "続行する前に、対応する役割がすべて正常にインポートされていることを確認してください。JSON ファイルの選択が求められます。",
    importGroupRoleConfirmWarning:
      "この JSON インポートは既存の設定を上書きする場合があります。",
    importGroupRoleConfirmP2:
      "ファイルの内容に応じて、次の一致するレコードが置き換えられる場合があります。",
    importGroupRoleConfirmLi1: "ユーザーグループ",
    importGroupRoleConfirmLi2: "ユーザーグループと役割のマッピング",
    importGroupRoleConfirmLi3: "タグ",
    importGroupRoleConfirmLi4: "Dimensions",
    exportUserGroupAndRole: "Export User Group & Role",
    exportUserGroupWithRolesJson: "Export User Group with Roles (JSON)",
    userGroup: {
      label: "ユーザーグループ",
      userGroupName: "ユーザーグループ名",
    },
    dimensions: "Dimensions",
    dimension: "Dimension",
    values: "Values",
    addDimension: "+ Add Dimension",
    searchDimension: "Search dimension",
    searchValues: "Search values",
    selectDimensionFirst: "Select a dimension first",
    noDimensionMatch: "No dimension match",
    noValueMatch: "No values match",
    noOptions: "データがありません",
    noDataAvailable: "利用可能なデータがありません",
    noResultsFound: "該当する結果が見つかりませんでした",
    removeDimension: "Remove",
    tip: {
      updateStatusSuccess: "ユーザーグループ ステータスが更新されました。",
      updateSuccess: "ユーザーグループが更新されました。",
      dimensionsSaved: "ディメンションが保存されました。",
      addSuccess: "ユーザーグループが作成されました。",
      exists: "このユーザーグループはすでに登録されています。",
      associatedSuccess: "ユーザーグループの関連付けが設定されました。",
      disassociatedSuccess: "ユーザーグループが解除されました。",
      deleteSuccess: "ユーザーグループが削除されました。",
      exportGroupConfigSuccess: "ユーザーグループ設定をエクスポートしました。",
    },
  },
  accessControlManager: {
    accessControls: "アクセス制御",
    description:
      "アクセス制御機能により、ユーザーに対して特定の権限セットを作成することができます。",
    privilege: "権限",
    deleteACL:
      "選択されたアクセス制御が削除されます。続行しますか？",
    importACLWithPrivilegeDetails: "Import ACL with Priviledge Details",
    importACLWithoutPrivilegeDetails: "Import ACL with out Priviledge Details",
    importAclJsonConfirmTitle: "ACL のインポート（特権付き JSON）",
    importAclJsonConfirmP1:
      "JSON 設定ファイルの選択が求められます。",
    importAclJsonConfirmWarning:
      "この JSON インポートは既存の設定を上書きする場合があります。",
    importAclJsonConfirmP2:
      "ファイルの内容に応じて、次の一致するレコードが置き換えられる場合があります。",
    importAclJsonConfirmLi1: "アクセス制御（ACL）",
    importAclJsonConfirmLi2: "権限",
    exportACLWithPrivilegeDetails: "Export ACL with Priviledge Details",
    exportACLWithPrivilegesJson: "Export ACL with Privileges (JSON)",
    accessControl: {
      label: "アクセス制御",
      label1: "ACL",
      name: "の名前をあげる",
      aclName: "ACL名",
      quickSightManagement: "クイックサイト管理",
      dataManagement: "データ管理",
      processManagement: "プロセス管理",
      addQuicksight: "クイックサイトダッシュボードを追加",
      quicksightTitle: "クイックサイトダッシュボード {{index}}",
      labelInPop1: "モジュール名",
      labelInPop2: "クイックサイトリスト",
      addProcessPrivileges: "プロセステンプレートの権限を追加",
      editProcessPrivileges: "プロセステンプレートの権限を編集",
      labelInPop3: "プロセステンプレート",
      labelInPop4: "ドメイン",
      labelInPop5: "アクション"
    },
    tip: {
      updateStatusSuccess:
        "アクセス制御ステータスが更新されました。",
      updateSuccess: "アクセス制御が更新されました。",
      addSuccess: "アクセス制御が作成されました。",
      privilegeExists: "権限がすでに登録されています。",
      exists: "アクセス制御がすでに登録されています。",
      associatedSuccess: "アクセス制御の関連付けが設定されました。",
      disassociatedSuccess:
        "アクセス制御が解除されました。",
      deleteSuccess: "アクセス制御が削除されました。",
      exportACLConfigSuccess: "ACL configuration has been exported successfully.",
    },
  },
  distributionManager: {
    distribution: "配信",
    distributionName: "配信名",
    emailIdCount: "メールアドレス数",
    recordID: 'レコードID',
    createdBy: "作成者",
    createdOn: "作成日",
    modifiedOn: "更新日",
    description: "説明",
    searchAndEmail: "メールアドレスを検索して追加",
    deleteDistribution: "選択された配信は削除されます。続行しますか？",
    tip: {
      addSuccess: "配信が作成されました。",
      updateSuccess: "配信が更新されました。",
      deleteSuccess: "配信さ削除されました。",
      repeatError: "固有のメールアドレスを入力してください。"
    },
    verify: {
      name: "配信名は必須項目です"
    },
    identifiers: {
      title: "識別子を管理する",
      tagTitle: "フィルタアイテム"
    }
  },
  clientManager: {
    client: "Client",
    addClient: "Add Client",
    clientInformation: "Client Information",
    clientName: "Client Name",
    clientNameHint:
      "Names are limited to 128 characters or fewer. Names may only contain alphanumeric characters, spaces, and the following special characters: + = , . @ -",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    host: "Host",
    scope: "Scope",
    addExampleCodeTitle: "Add the example code to your application",
    getAccessTokenDescription: "Get an access token with a custom scope.",
    showClientSecret: "Show client secret",
    hideClientSecret: "Hide client secret",
    copyClientSecret: "Copy Client Secret",
    copyClientId: "Copy Client ID",
    copyHost: "Copy Host",
    copyScope: "Copy Scope",
    copyConnectionInfo: "Copy connection information",
    copyExampleCode: "Copy example code",
    roles: "Roles",
    role: "Role",
    addRole: "Add Role",
    removeRole: "Remove Role",
    deleteClient: "The selected client will be deleted. Do you wish to proceed?",
    deleteClientWithDependency:
      "Are you sure you want to delete this client as it has dependencies?",
    clientQuotaReached:
      "The maximum number of clients is {{quota}}. If you need to add more clients, please contact the Freya Fusion Support Team.",
    tip: {
      addSuccess: "Client has been created successfully.",
      updateSuccess: "Client has been updated successfully.",
      addRoleSuccess: "Role has been added successfully.",
      removeRoleSuccess: "Role has been removed successfully.",
      deleteSuccess: "Client has been deleted successfully.",
      clientSecretCopied: "Client Secret copied to clipboard.",
      clientSecretCopyFailed: "Unable to copy Client Secret.",
      clientSecretQueryFailed: "Unable to retrieve the Client Secret. Please try again.",
      clientIdCopied: "Client ID copied to clipboard.",
      clientIdCopyFailed: "Unable to copy Client ID.",
      hostCopied: "Host copied to clipboard.",
      hostCopyFailed: "Unable to copy Host.",
      scopeCopied: "Scope copied to clipboard.",
      scopeCopyFailed: "Unable to copy Scope.",
      connectionInfoCopied: "Connection information copied to clipboard.",
      connectionInfoCopyFailed: "Unable to copy connection information.",
    },
    verify: {
      clientName: "Client Name is required",
      clientNameFormat:
        "Names are limited to 128 characters or fewer. Names may only contain alphanumeric characters, spaces, and the following special characters: + = , . @ -",
      clientId: "Client ID is required",
    },
  },
  audit: {
    label: "監査レポート",
    description:
      "監査レポートは、セキュリティと信頼性を保持する目的で、システム内のすべての活動とイベントを追跡し記録します。",
    filter: {
      startDate: "開始日",
      endDate: "終了日",
      startDateTime: "Start DateTime",
      endDateTime: "End DateTime",
    },
    grid: {
      auditIdentifier: "監査ID",
      moduleName: "モジュール",
      operatorUsername: "ユーザー",
      operationType: "操作タイプ",
      operationDate: "操作日時",
      entityIdentifier: "企業ID",
      entityName: "企業名",
      fieldName: "フィールド名",
      reason: "Reason",
      beforeModification: "修正前",
      afterModification: "修正後",
      notes:
        "注：この表には、この手続きの実行中に更新されたフィールドのみが表示されています",
    },
    compareAudit: "Compare Audit",
    truncateFileTip: " ... Content truncated due to size limit. Displaying {{maxLines}} of {{totalLines}} total lines.",
    exportLimitExceeded: {
      title: "Export Limit Exceeded",
      message: "The total record count exceeds the limit of {{limit}}. Please apply a date range filter to reduce the number of records before exporting.",
    }
  },
  report: {
    module: "モジュール",
    reportType: "レポート種別",
    reportName: "レポート名",
  },
  systemSettings: {
    title: "設定",
    sessionTimeOut: {
      logout: 'Your session is about to expire. Please log in again.',
      title: 'Session Timeout',
      prompt: 'Your session is about to expire. Do you want to extend your session?',
      min: 'Min',
      sec: 'Sec'
    }
  },
  notification: {
    domainName: "領域名",
    moduleName: "モジュール名",
    fieldName: "フィールド名",
    templateId: "テンプレートID",
    templateName: "テンプレート名",
    createdDate: "作成日",

    payloads: "ペイロード",
    payloadId: "ペイロードID",
    notificationPayload: "ペイロード通知",
    remarks: "備考",
    status: "ステータス",

    tasks: "タスク",
    taskId: "タスクID",
    taskType: "タスク区分",
    scheduledDate: "過去の予定日",
    lastScheduledDate: "今後の予定日",
    endDate: "終了日",

    history: "履歴",
    notificationContent: "通知内容",
    receiver: "受信者",

    Templates: "テンプレート",
    cancelTask: "タスクをキャンセル",
    tips: {
      copiedSuccess: "コピーに成功しました",
      cancelSucess: "タスクのキャンセルに成功しました"
    },

    basic: {
      tab: "テンプレート設定",
      title: "通知作成のテンプレートリスト",
      addTemplate: "テンプレートを追加",
      editTemplate: "テンプレートを編集",
      templatedescription: "テンプレート説明",
      notificationType: "通知区分",
      notificationChannels: "通知方法",
      condition: "条件",
      interval: "間隔",
      intervalUnit: "間隔の単位",
      frequency: "頻度",
      notificationDisabled: "テンプレートを使用停止する",
      deleteTemplate: "テンプレートを削除",
      tips: {
        deleteSuccess: "テンプレートを削除しました",
        deleteOne: "削除するデータを選択してください",
        deleteConfirm: '選択したテンプレートは<b class="alert-text">削除</b>.<br />続行しますか？',
        updatedSuccess: "テンプレートを更新しました",
        addSuccess: "テンプレートを追加しました"
      }
    },
    conditions: {
      tab: "条件",
      addCondition: "条件を追加",
      conditionField: "条件フィールド",
      operator: "オペレーター",
      value: "値",
      tips: {
        addAtAime: "一度に追加できるのは1行のみです",
        addSuccess: "条件が追加されました",
        updatedSuccess: "条件が更新されました",
        deleteSuccess: "条件が削除されました",
      }
    },
    content: {
      tab: "テンプレート内容",
      subjectTitle: "件名タイトル",
      templateTitle: "テンプレートタイトル",
      templateContent: "テンプレート内容",
      email: "メール",
      fields: "フィールド",
      tips: {
        updatedSuccess: "テンプレートの内容が更新されました",
      }
    },
  },
  processManager: {
    template: "テンプレート",
    id: "プロセス テンプレートID",
    processTemplateName: "プロセステンプレート名",
    processType: "プロセスタイプ",
    processTemplateDescription: "プロセステンプレートの説明",
    processTemplateVersion: "プロセステンプレートのバージョン",
    editDetails: "詳細を編集",
    addDetails: "詳細を追加",
    editBPMN: "BPMNを編集",
    domains: "領域",
    addBPMN: "BPMNを追加",
    taskManager: {
      taskProperties: 'タスクプロパティ',
      taskId: "タスクID",
      taskName: "タスク名",
      displayName: "表示名",
      moduleName: "モジュール名",
      domainName: "領域名",
      updateName: "表示名を更新",
      order: "順序",
      propertyName: "プロパティ名",
      property: "プロパティ",
      configurability: "設定カスタマイズ",
      fixed: "固定",
      configurable: "設定変更可能",
      configurabilityInfo: "固定 は、プロセス実行中にフィールド値が変更できないことを意味し、設定変更可能 は実行時に値を上書きすることを許可します。",
      detailsPage: {
        sectionTitle: "プロセス詳細ページ設定",
        visibility: "可視性",
        visibilityInfo: "可視性フィールドは、このフィールドがプロセス詳細ページに表示されるかどうかを決定します。"
      }
    }
  },
  appLauncher: {
    app: {
      title: "Freya Fusion",
      subTitle: "業務モジュールとコア機能へのアクセス",
    },
    tenant: {
      title: "プラットフォーム",
      subTitle: "Freyr プラットフォームレベルの設定がFreyrの管理者により管理されています",
    },
  },
  taskManager: {
    tag: 'タグ',
    key: 'キー',
    value: '値',
    remove: '削除',
    addTag: 'タグを追加',
    verify: {
      empty: "これは必須項目です",
      unique: '各キーは固有である必要があります'
    },
    successTip: 'タグが正常に保存されました。'
  },
  // Identifier
  filter: {
    clear: "パージ",
    searchIntro: "選択または逆選択でコンテンツをフィルタリングすることができます。",
    selected: "選択済み",
    beforeThanPlaceholder: "日付を選択してください",
    more: "その他",
    total: "合計",
    filterItems: {
      label: "フィルタアイテム",
      totalLabel: "すべてのフィルタ項目",
      searchPlaceholder: "フィルタアイテムの取得",
    },
  },
  modal: {
    editIdentifiers: {
      title: "識別子を管理する"
    }
  }
};
